var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SfButton',{staticClass:"sf-button--text a-add-to-wishlist",class:{ 'is-on-wishlist': _vm.isOnWishlist },attrs:{"data-testid":"addToWishlist"},on:{"click":function($event){_vm.isOnWishlist
      ? _vm.removeProductFromWhishList(_vm.product)
      : _vm.addProductToWhishlist(_vm.product)}}},[_vm._v("\n  "+_vm._s(!_vm.isOnWishlist ? _vm.$t("Save for later") : _vm.$t("Remove"))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }